import React, {Dispatch, SetStateAction, useState, useEffect, memo} from 'react';
import {FormikErrors, useField, useFormikContext} from "formik";
import s from "./CustomDropdownForAccounts.module.css";
import selectArrow from "../../../assets/img/select_arrow.svg";
import classnames from "classnames";

type PropsType = {
    items: any
    isError?: string | string[] | FormikErrors<any> | FormikErrors<any>[] | undefined
    setCountryError?: any
    placeholder?: string
    otherFieldName?: string
    id: string
    name?: any
    touched?: any
    customId?: string
    disabled?: boolean
    setCurrency?: Dispatch<SetStateAction<string>>
    setAccountNumber?: Dispatch<SetStateAction<string>>
    setDisabled?: Dispatch<SetStateAction<boolean>>
}

const CustomDropdownForAccounts = memo((props: PropsType) => {

    const [isDropdownVisible, setIsDropdownVisible] = useState(false)

    const {values, setFieldValue}: any = useFormikContext();
    const [field] = useField<string>(props.name);



    if (isDropdownVisible) {
        const myPopup: any = document.querySelector(`#${props.id}`);
        document.addEventListener('click', (e) => {
            const withinBoundaries = e.composedPath().includes(myPopup);

            if (!isDropdownVisible) return

            if (!withinBoundaries) {
                setIsDropdownVisible(false)
            }
        })
    }

    useEffect(() => {
        if (props.setDisabled) {
            props.setDisabled(field.value === '')
        }
    }, [field.value])

    return (
        <div className={s.dropdownWrapper} id={props.id}>
            <div className={s.mySelect} onClick={(e) => {
                if (props.disabled) {
                    return
                }
                e.stopPropagation()
                setIsDropdownVisible(prevState => !prevState)
            }}>
                <div className={s.selectedBlock}>
                    <img className={classnames( props.disabled && s.disabledArrow, isDropdownVisible && s.arrowReverse, s.arrow)} width={9} height={5}
                         src={selectArrow} alt=""/>
                </div>
                <div className={isDropdownVisible ? s.optionsWrapper : s.none}>
                    {
                        props?.items?.filter((item: any) => item.currency !== "USD").map((item: any, index: number) => <div className={s.option}
                                                                 key={index}
                                                                 onClick={() => {
                                                                     if (props.name != null) {
                                                                         setFieldValue(props.name, item.accountMainIban)
                                                                         setFieldValue(props.name + 'Currency', item.currency)

                                                                         if (props.setCurrency) {
                                                                             props.setCurrency(item.currency)
                                                                         }
                                                                         if (props.setAccountNumber) {
                                                                             props.setAccountNumber(item.number)
                                                                         }

                                                                     }
                                                                 }}>
                            <div className={s.countryName}>
                                {item.accountMainIban} {item.balance} {item.currency}
                            </div>
                        </div>)
                    }
                </div>
            </div>
            <input
                {...field}
                className={classnames(s.my_input, props.isError && props.touched && s.error, props.disabled && s.disableInput)}
                id={props.id}
                name={props.name}
                type="text"
                value={field.value}
                placeholder={props.placeholder}
                disabled={props.disabled}
            />
        </div>
    );
});

export default CustomDropdownForAccounts;
